import { fetchApi } from '@/config/axiosSetting.ts';
import { DeactivateQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deactivate/deactivateQuery.type';

export const DeactivateQueryFunction = (
  id: string,
  params?: DeactivateQueryParamsType,
) =>
  fetchApi({
    method: 'PATCH',
    url: `/property/reports/${id}/accident_users/damaged/deactivate/`,
    data: params,
  });
